let district = [
    { "x": -1, "y": -1, "type": "right", "opts": "start", "pickup": false },
    { "x": -3, "y": -2, "type": "righttoleft" },
    { "x": -3, "y": -3, "type": "lefttop" },
    { "x": -4, "y": -4, "type": "topright" },
    { "x": -5, "y": -4, "type": "righttop" },
    { "x": -6, "y": -5, "type": "topright" },
    { "x": -7, "y": -5, "type": "right" },
    { "x": -8, "y": -5, "type": "right" },
    { "x": -9, "y": -5, "type": "voidright" },
    { "x": -10, "y": -5, "type": "righttop" },
    { "x": -11, "y": -6, "type": "top" },
    { "x": -12, "y": -7, "type": "top" },
    { "x": -13, "y": -8, "type": "top" },
    { "x": -14, "y": -9, "type": "topleft" },
    { "x": -18, "y": -18, "type": "plateforme214", "pickup": false },

    /* Fake path */
    { "x": -19, "y": -14, "type": "right", "pickup": false }, 
    { "x": -20, "y": -14, "type": "left", "pickup": false },
    { "x": -21, "y": -14, "type": "left", "pickup": false },
    { "x": -22, "y": -14, "type": "left", "pickup": false },
    { "x": -23, "y": -14, "type": "left", "pickup": false },
    { "x": -24, "y": -14, "type": "left", "pickup": false },

    { "x": -9, "y": -14, "type": "right", "pickup": false },
    { "x": -8, "y": -15, "type": "righttoptolefttop", "pickup": false },
    { "x": -7, "y": -16, "type": "left", "pickup": false },
    { "x": -7, "y": -17, "type": "left", "pickup": false },
    /* */

    {
        "x": -26,
        "y": -26,
        "type": "lisboahotel",
        "move": false,
        "pickup": false
    },
    { "x": -15, "y": -20, "type": "lefttoright" },
    { "x": -16, "y": -20, "type": "right" },
    { "x": -17, "y": -20, "type": "right" },
    { "x": -18, "y": -20, "type": "voidright" },
    { "x": -19, "y": -20, "type": "righttop" },
    { "x": -20, "y": -21, "type": "top" },
    { "x": -21, "y": -22, "type": "top" },
    { "x": -22, "y": -23, "type": "topleft" },
    { "x": -22, "y": -24, "type": "left" },
    { "x": -23, "y": -26, "type": "lefttoright" },
    { "x": -24, "y": -26, "type": "right" },
    { "x": -25, "y": -26, "type": "voidright" },
    { "x": -26, "y": -26, "type": "righttop" },
    { "x": -27, "y": -27, "type": "top" },
    { "x": -28, "y": -28, "type": "top" },
    { "x": -29, "y": -29, "type": "voidbottop" },
    { "x": -30, "y": -30, "type": "topleft" },
    { "x": -30, "y": -31, "type": "lefttop" },
    { "x": -31, "y": -32, "type": "topright", "pickup": false },
    { "x": -32, "y": -32, "type": "right", "opts": "end", "pickup": false }
];

export default district;